import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ShareToolTabLeftSection = ({
  children
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Flex, {
    inlineSize: "44%",
    blockSize: "100%",
    alignItems: "stretch",
    flexDirection: "column",
    children: /*#__PURE__*/_jsx(ScrollContainer, {
      children: children
    })
  }), /*#__PURE__*/_jsx(View, {
    inlineSize: "6%",
    blockSize: "100%"
  })]
});
export const ShareToolTabRightSection = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  inlineSize: "50%",
  children: /*#__PURE__*/_jsx(ScrollContainer, {
    children: children
  })
});
export const ShareToolTabWholeSection = ({
  children,
  dataTestId
}) => /*#__PURE__*/_jsx(Flex, {
  inlineSize: "auto",
  blockSize: "100%",
  alignItems: "stretch",
  flexDirection: "column",
  children: /*#__PURE__*/_jsx(ScrollContainer, {
    "data-test-id": dataTestId,
    children: children
  })
});
export const ShareToolFormContainer = styled.div.withConfig({
  displayName: "ShareToolLayout__ShareToolFormContainer",
  componentId: "zth6t-0"
})(["padding-left:2px;padding-right:16px;"]);